import type { AvatarTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const avatarDark: AvatarTheme = {
  name: 'Avatar',
  common: commonDark,
  self
}

export default avatarDark
